import { html, SYSConfig } from "../../../../"
import { FocusSet } from "../../../../global/globalapi"
import { stringifyReplacer, T } from "../../../../global/globals"
import { _RenderTracking } from "../../../../tracker/tracker"
import { DialogIsOpen } from "../../../dialog/dialogapi"
import { SYSBaseElement } from "../../../sysbaseelement"
import { GetDisplayValueByType } from "../../../table/helpers"
import type { ListDefinition } from "../../../table/table"
import type { SYSField } from "../../actions"
import { DataType } from "../../sysformelement"
import { FilterHitList } from "../helpers"
import type { ListState } from "../listcontrol"

export type HitListState = {
  selectedFieldKey: string
  fieldId: string
  list: ListState
  listData: ListDefinition
  filterValue: string
  filteredKeys: string[]
  type: "inline" | "overlay"
  animation: boolean
  selectedCallback?: any
  // following fields are only used from inline mode
  field?: SYSField
  directHit?: { value: any; description: any }
}

export class SYSHitList extends SYSBaseElement {
  props: any
  controlState: HitListState
  focusSet: boolean
  maxRow: number

  async init() {
    this.focusSet = false
    this.controlState = this.props(this.state)
    // read this one so its a dependency and we can force rerender by toggling it
    await super.init()
  }

  handleKeyDown(e: KeyboardEvent, rowKey: string) {
    if (e.key === "Enter") {
      e.preventDefault()
      e.stopPropagation()
      this.controlState.selectedCallback(rowKey)
      //this.click()
    } else if (e.key === "ArrowUp" || (e.key === "Tab" && e.shiftKey)) {
      e.preventDefault()
      e.stopPropagation()

      let previousEl = document.getElementById(
        //@ts-ignore
        e.target.id
      ).previousElementSibling
      if (previousEl) {
        //@ts-ignore
        previousEl.focus()
      } else {
        if (this.controlState.type === "inline") {
          this.controlState.selectedCallback("@@ovlcanceled")
        }
      }
    } else if (e.key === "ArrowDown" || e.key === "Tab") {
      let dialogOpen = DialogIsOpen("SYSHitListDialog")
      e.stopPropagation()
      if (!dialogOpen) {
        e.preventDefault()
      }
      //@ts-ignore
      let nextEl = document.getElementById(e.target.id).nextElementSibling

      if (nextEl) {
        e.preventDefault()
        //@ts-ignore
        nextEl.focus()
      } else {
        if (dialogOpen) {
          return
        }
      }
    }
    if (e.key === "Tab") {
      e.preventDefault()
    }
  }

  handleClick(e: Event, key: string) {
    //@ts-ignore
    this.controlState.selectedCallback(key)
  }

  handleMainKeyDown(e: KeyboardEvent) {
    e.stopPropagation()
    if (e.key === "Escape") {
      //if (this.controlState.type === "overlay") {
      this.controlState.selectedCallback("@@ovlcanceled")
      //this.click()
      // } else {
      //   this.controlState.selectedCallback("@@ovlescape")
      //}
    }
  }

  async getUI() {
    let rowNr = 0
    let list = this.controlState.list
    let listData = this.controlState.listData
    let filterValue = list.filterValue
    let filteredKeys = this.controlState.filteredKeys

    let filterRes
    if (!filteredKeys) {
      let field = this.controlState.field
      let formState = this.state.ovl.forms[field.formType][field.formId]
      filterRes = FilterHitList(
        list,
        filterValue,
        formState,

        field.fieldKey,
        10,
        false,
        this.controlState.type
      )

      filteredKeys = filterRes.filteredKeys
      this.controlState.directHit.value = filterRes.directValue
      this.controlState.directHit.description = filterRes.directDescription
    }

    if (filteredKeys.length === 0) {
      return null
      //filteredKeys = Object.keys(FieldCurrentList(this.controlState.field).data)
    }
    let animation = ""
    if (this.controlState.animation) {
      animation = "animated fadeIn faster"
    }
    let lookupTypes = listData.lookupDef
    if (!lookupTypes) {
      // get the types from the data and assume its text
      let keys = Object.keys(listData.data)
      if (keys.length > 0) {
        lookupTypes = Object.keys(listData.data[keys[0]]).reduce((val, k) => {
          val[k] = { type: "text" }
          return val
        }, {})
      }
    }
    // check if we should remove the valueField from the displayed list
    if (
      Object.keys(lookupTypes).length > 1 &&
      list.displayValueField !== undefined &&
      list.displayValueField === false
    ) {
      // we have to clone it in order to remove an entry...its proxified thats why
      lookupTypes = JSON.parse(JSON.stringify(lookupTypes), stringifyReplacer)
      delete lookupTypes[list.valueField]
    }

    // if they lookupTypes contains an order property sort by that
    // thats just in case serialisation and deserialisation doesn't keep order (which it does in my current tests with .NET6 Json.TEXT and Chrome at least)

    let lookupTypesKeys = Object.keys(lookupTypes) /*.filter(
      (f) =>
        lookupTypes[f].ignoreForSearch !== true &&
        lookupTypes[f].type !== "html"
    )*/

    if (lookupTypesKeys.some((f) => lookupTypes[f].order !== undefined)) {
      lookupTypesKeys = lookupTypesKeys.sort(
        (s1, s2) => (lookupTypes[s1].order, lookupTypes[s2].order)
      )
    }

    let thead
    if (this.controlState.type === "overlay") {
      if (
        lookupTypesKeys.length > 0 &&
        lookupTypesKeys.filter((f) => lookupTypes[f].translationKey).length > 0
      ) {
        thead = html`
          <thead class="fd-table__header">
            <tr class="fd-table__row">
              ${lookupTypesKeys.map((k) => {
                if (!lookupTypes[k].translationKey) {
                  return html`<th class="fd-table__cell stickyTableHeader">
                    <br />
                  </th>`
                }
                let caption = ""
                if (lookupTypes[k].translationKey) {
                  caption = T(lookupTypes[k].translationKey)
                } else {
                  caption = k
                }

                return html`
                  <th class="fd-table__cell stickyTableHeader" scope="col">
                    ${caption}
                  </th>
                `
              })}
            </tr>
          </thead>
        `
      } else {
        thead = html`<thead class="fd-table__header">
          <tr class="fd-table__row"></tr>
        </thead>`
      }
    }
    // it needs to be excact if we also accept non list values.
    // Elsewise if there is Option "A" and the user enters "a", "A" eventually will be selected whereas the user really wanted "a"
    let exact = false
    if (
      this.controlState.field &&
      this.controlState.field.list?.acceptOnlyListValues === false
    ) {
      exact = true
    }
    let isZebra = SYSConfig.tableDefaults?.rendering?.zebra === "vertical"
    let cellAlignment = SYSConfig.tableDefaults?.rendering?.cellAlignment
    return html`
      <div
        id="ovlhitlist"
        class=${`ovl-hitlist ${isZebra ? "ovl-zebra-vertical" : ""} ${cellAlignment === "top" ? "ovl-cellalignment-top" : ""}`}
        @keyup=${(e) => this.handleMainKeyDown(e)}
      >
        <table class=${`fd-table ${animation}`}>
          ${thead}
          <tbody class="fd-table__body">
            ${filteredKeys.map((rowKey) => {
              let row = listData.data[rowKey]
              rowNr++
              this.maxRow = rowNr
              return html`
                <tr
                  @click=${(e) => this.handleClick(e, rowKey)}
                  id=${`${this.controlState.fieldId}${
                    this.controlState.type
                  }ovlhl_${CSS.escape(rowKey)}`}
                  tabindex="0"
                  class="fd-table__row ovl-hitlist-row fd-table__row--hoverable"
                  @keydown=${(e) => this.handleKeyDown(e, rowKey)}
                >
                  ${lookupTypesKeys.map((c) => {
                    let rawVal = row[c]
                    let val = rawVal
                    let filterHit = false
                    let hasNewline = false
                    if (typeof rawVal !== "object") {
                      val = GetDisplayValueByType(
                        undefined,
                        <DataType>lookupTypes[c].type,
                        rawVal
                      )
                      if (typeof val !== "string") {
                        val = val.toString()
                      }
                      val = val
                        .split("\n")
                        .map((line) => line.trim())
                        .filter(Boolean)
                        .join("\n")
                      hasNewline =
                        typeof val === "string" && val.indexOf("\n") > -1
                      // let val = getDisplayValue(
                      //   c,
                      //   { type: <DataType>lookupTypes[c].type, ui: {} },
                      //   row[c],
                      //   undefined
                      // )

                      if (c !== undefined) {
                        let leftPart = ""
                        let rightPart = ""
                        // mark hits
                        if (filterValue) {
                          let _val = val
                          let _filterValue = filterValue
                          if (!exact) {
                            _val = _val.toLowerCase()
                            _filterValue = _filterValue.toLowerCase()
                          }
                          let i = _val.indexOf(_filterValue)
                          if (i > -1) {
                            leftPart = val.substring(0, i)
                            rightPart = val.substring(i + filterValue.length)
                            val = val.substring(i, i + filterValue.length)
                            filterHit = true
                            /* prettier-ignore */
                            return html`<td class=${`fd-table__cell ${lookupTypes[c].noWrap ? "ovl-text-nowrap" : ""} ${hasNewline ? "ovl-text-break" : ""}`}>${leftPart}<b><i>${val}</i></b>${rightPart}</td>`
                          }
                          }
                          }
                          }

                          if (!filterHit) {
                          /* prettier-ignore */
                          return html`<td class=${`fd-table__cell ${lookupTypes[c].noWrap ? "ovl-text-nowrap" : ""} ${hasNewline ? "ovl-text-break" : ""}`}>${val}</td>`
                          }
                  })}
                </tr>
              `
            })}
          </tbody>
        </table>
      </div>
    `
  }
  async updated() {
    if (this.controlState.type !== "inline" && !this.focusSet) {
      this.focusSet = true
      let el
      if (
        this.controlState.list.mode !== "Option" &&
        this.controlState.selectedFieldKey !== undefined
      ) {
        el = document.getElementById(
          this.controlState.fieldId +
            this.controlState.type +
            "ovlhl_" +
            CSS.escape(this.controlState.selectedFieldKey)
        )
      }

      if (!el) {
        el = <HTMLElement>document.getElementsByClassName("ovl-hitlist-row")[0]
      }
      FocusSet(el.id)
    }
  }
}
